import { connect } from 'react-redux';
import PmChecklistQues from './pmChecklistQues';
import { bindActionCreators } from 'redux';
import {
  fetchPmQues,
  postPmAnswer,
} from 'services/redux/maintenance/pmSities/action';
import { documentUploadUrl } from 'services/redux/fileUpload/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  pmChecklistQues: state.pmSitiesReducer.pmChecklistQues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmQues,
      postPmAnswer,
      documentUploadUrl,
      documentUploadUrlPublic
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PmChecklistQues);
